import React, { useState } from "react";
import { useLanguage } from "../LanguageProvider";
import AjanloiProgramUjRegisztracioModal from "./AjanloiProgramUjRegisztracioModal";

export default function AffiliateSection() {
  const [modalOpen, setModalOpen] = useState(false);
  const { dict } = useLanguage();
  const affiliate = dict.affiliate || {};
  return (
    <section className="py-20 bg-section">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-6 tracking-tight">
          {affiliate.sectionTitle || "Ajánlói rendszer"}
        </h2>
        <p className="text-gray-300 text-lg mb-8">
          {affiliate.description || "Ajánld ismerőseidnek a HoppHomes moduláris otthonokat, és részesülj minden sikeres ajánlás után jutalékban! Regisztrálj partnerként, és kövesd nyomon az ajánlásaidat egy modern partnerportálon keresztül."}
        </p>
        <button
          className="bg-secondary hover:bg-hover text-primary font-bold px-8 py-4 rounded-modulive text-lg shadow-glow-turquoise transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-secondary/60 focus:ring-offset-2 hover:scale-105"
          tabIndex={0}
          aria-label={affiliate.ariaLabel || affiliate.cta || "Regisztrálj partnerként"}
          onClick={() => setModalOpen(true)}
        >
          {affiliate.cta || "Regisztrálj partnerként"}
        </button>
      </div>
      <AjanloiProgramUjRegisztracioModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </section>
  );
}
